var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('main-slider-for-curator-and-teacher'),_c('main-middle-panel-for-curator-and-teacher')],1)}
var staticRenderFns = []

export { render, staticRenderFns }